// extracted by mini-css-extract-plugin
export default {"root":"Download__root--hfVmp","text":"Download__text--Y5TOP","button":"Download__button--fLC5U"};